import { createIsFetchingReducer } from '../../helpers/reducers';
import { types } from '../../actions/search';

const initialState = true;

const apiActionTypes = [
  types.SEARCH_QUERY,
];

const isFetching = createIsFetchingReducer(initialState, apiActionTypes);

export default isFetching;

export const getIsFetching = state => state.search.isFetching;



// WEBPACK FOOTER //
// ./src/reducers/search/isFetching.js